/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useRef, useState } from 'react'
import Slider from 'react-slick';
import { makeStyles } from '@material-ui/styles';
import { bool, number } from 'prop-types';

const useStyles = (props) => makeStyles((theme) => ({
    sliderContainer: {
        width: '100%',
        maxWidth: '100%',
        overflow: 'hidden',
        zIndex: '2',
        '& .slick-track': {
            display: 'flex',
            padding: '10px 0',
            margin: '0 auto',
        },
        '& .slick-dots': {
            marginTop: '15px',
            listStyleType: 'none',
            display: 'flex !important',
            gap: '10px',
            justifyContent: 'center',
            padding: 0,
            margin: 0,
        },
        '& .slick-slide': {
            padding: props.mobile ? '0 5px' : '0 9px',
            width: props.slideWithStyle,
            minWidth: props.slideWithStyle,
            maxWidth: props.slideWithStyle,
            height: 'auto',
            '& > div': {
                height: '100%',
            },
            [theme.breakpoints.down(props.slideWidth)]: {
                minWidth: 'calc(100vw - 90px);',
                maxWidth: 'calc(100vw - 90px);',
            },
            '& MuiCard-root': {
                boxShadow: 'none',
            },
            '& img': !props.products && {
                objectFit: 'cover',
                aspectRatio: '9 / 16',
            },
        },
    },
    sliderCenter: {
        '& .slick-track': {
            justifyContent: 'center',
        },
    },
}));

const Carousel = ({ children, length, slideWidth, mobile, products }) => {
    if (typeof window === 'undefined') return null;

    const classes = useStyles({
        slideWidth, slideWithStyle: `${slideWidth}px`, mobile, products,
    })();


    const [slidesShowing, setSlidesShowing] = useState(length);
    const [windowInnerWidth, setWindowInnerWidth] = useState(window.innerWidth);
    const sliderContainer = useRef(null);
    const sliderRef = useRef(null);

    const handleSlidesShowing = () => {
        if (!sliderContainer?.current) return;
        const element = sliderContainer.current;

        const slidesToShow = Math.floor(element.clientWidth / slideWidth);

        if (slidesToShow <= 1) {
            setSlidesShowing(1);
        } else if (slidesToShow >= length) {
            setSlidesShowing(length);
        } else setSlidesShowing(slidesToShow);
    };

    const handleResize = () => {
        setWindowInnerWidth(window.innerWidth);
    };


    useEffect(() => { handleSlidesShowing(); }, [windowInnerWidth]);

    useEffect(() => {
        handleSlidesShowing();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div ref={sliderContainer} className={`${classes.sliderContainer} ${(slidesShowing === length) && classes.sliderCenter}`}>
            <Slider
                speed={500}
                infinite={false}
                easing="ease-in"
                focusOnSelect
                swipeToSlide={true}
                slidesToShow={slidesShowing}
                variableWidth
                ref={sliderRef}
                arrows={false}
            >
                {children}
            </Slider>
        </div>
    );
}

Carousel.defaultProps = {
    products: false,
}

Carousel.propTypes = {
    length: number.isRequired,
    slideWidth: number.isRequired,
    mobile: bool.isRequired,
    products: bool,
}

export default Carousel